import { render, staticRenderFns } from "./ChooseTicketGood.vue?vue&type=template&id=bd5b2d1c&scoped=true"
import script from "./ChooseTicketGood.vue?vue&type=script&lang=js"
export * from "./ChooseTicketGood.vue?vue&type=script&lang=js"
import style0 from "./ChooseTicketGood.vue?vue&type=style&index=0&id=bd5b2d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5b2d1c",
  null
  
)

export default component.exports